export default "__VITE_ASSET__BYl$GYWv__"